import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule } from '@psei/ng/icon';
import { PseicToasterComponent } from './pseic-toaster/pseic-toaster.component';

@NgModule({
    declarations: [PseicToasterComponent],
    imports: [
        CommonModule,
        OverlayModule,
        IconModule,
    ]
})
export class PseicToasterModule { }
